import { css, } from '@emotion/css';
import { Poster } from 'Shared/frontend/Poster';


const wrapStyle = () => css({
	/* TODO Put borders etc in here from theme */
});


/* 
	If a poster is to have a standard border, box shadow, etc, when displayed on the website then put it in here - not in Poster.tsx.  
	Note that Poster.tsx is used for social shares and should not include any border included here.
*/
export function PosterWrap(P:{children,settings})
{
	return (
		<div class={wrapStyle()}>
			<Poster theme={P.settings.theme} >
				{ P.children }
			</Poster>
		</div>
	);
}

